import React from 'react';

interface PricingToggleProps {
  isYearly: boolean;
  onToggle: () => void;
  currency: 'INR' | 'USD';
  onCurrencyToggle: () => void;
}

const PricingToggle: React.FC<PricingToggleProps> = ({
  isYearly,
  onToggle,
  currency,
  onCurrencyToggle,
}) => {
  return (
    <div className="flex justify-between items-center mb-12 w-full max-w-xl mx-auto">
      {/* Billing Cycle Toggle */}
      <div className="flex items-center space-x-3">
        <span
          className={`text-sm font-medium ${!isYearly ? 'text-black-600 font-bold' : 'text-gray-500'
            }`}
        >
          Monthly
        </span>
        <button
          onClick={onToggle}
          className="relative inline-flex h-6 w-11 items-center rounded-full bg-green-500 transition-colors hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${isYearly ? 'translate-x-6' : 'translate-x-1'
              }`}
          />
        </button>
        <span
          className={`text-sm font-medium ${isYearly ? 'text-black-600 font-bold' : 'text-gray-500'
            }`}
        >
          Yearly
        </span>
        {isYearly && (
          <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
            Save 20%
          </span>
        )}
      </div>

      {/* Currency Toggle */}
      <div className="flex items-center space-x-3">
        <span
          className={`text-sm font-medium ${currency === 'INR' ? 'text-black-600 font-bold' : 'text-gray-500'
            }`}
        >
          INR (₹)
        </span>
        <button
          onClick={onCurrencyToggle}
          className="relative inline-flex h-6 w-11 items-center rounded-full bg-green-500 transition-colors hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${currency === 'USD' ? 'translate-x-6' : 'translate-x-1'
              }`}
          />
        </button>
        <span
          className={`text-sm font-medium ${currency === 'USD' ? 'text-black-600 font-bold' : 'text-gray-500'
            }`}
        >
          USD ($)
        </span>
      </div>
    </div>
  );
};

export default PricingToggle;
